// Fill these from the Cognito console
export const REGION = process.env.REACT_APP_COGNITO_REGION || "us-east-1";
export const USER_POOL_ID = process.env.REACT_APP_COGNITO_USER_POOL_ID || "us-east-1_RlDBqnsmQ";
export const CLIENT_ID = process.env.REACT_APP_COGNITO_CLIENT_ID || "5vbpmf30r1ae0u6fjb3r7kl3lb";
